import { Input } from '../../components/ui/input.js';

/**
 * Campo para um código numérico de 6 dígitos — o mesmo na verificação e no MFA.
 *
 * Um input nativo, grande e espaçado, em vez de seis caixas: colar um código funciona,
 * o leitor de tela lê um campo só, e o autopreenchimento do SMS/e-mail encontra o
 * `autocomplete="one-time-code"`.
 */
export function CodeInput({
  value,
  onChange,
  autoFocus,
  label = 'Código de 6 dígitos',
}: {
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  label?: string;
}) {
  return (
    <Input
      aria-label={label}
      value={value}
      onChange={(event) => onChange(event.target.value.replace(/\D/g, '').slice(0, 6))}
      inputMode="numeric"
      autoComplete="one-time-code"
      autoFocus={autoFocus}
      maxLength={6}
      placeholder="••••••"
      className="h-14 text-center text-2xl font-semibold tracking-[0.5em] tabular-nums placeholder:tracking-[0.5em]"
    />
  );
}
